import Moment from 'moment';
import finishHolidays from 'finnish-holidays-js';
import { map, some } from 'lodash';

class MomentExtensions {
  private cache: { year: number; holidays: Moment.Moment[] } | null;

  constructor() {
    this.cache = null;
  }

  workingDaysDiff = (moment: Moment.Moment, param: Moment.Moment): number => {
    const d1 = moment.clone();
    const d2 = param.clone();
    const start = d1 < d2 ? d1 : d2;
    const end = d2 > d1 ? d2 : d1;

    let daysBetween = 0;

    if (start === end) {
      return daysBetween;
    }

    // NOSONAR
    while (start < end) {
      if (start.isBusinessDay()) {
        daysBetween += 1;
      }
      start.add(1, 'd');
    }

    return daysBetween;
  };

  isHoliday = (moment: Moment.Moment): boolean => {
    const thisMoment = moment.clone();
    const thisYear = thisMoment.year();

    const holidays = this.getYearsHolidays(thisYear);

    if (holidays && holidays.length > 0) {
      if (some(holidays, holiday => holiday.isSame(thisMoment, 'day'))) {
        return true;
      }
    }

    return false;
  };

  isBusinessDay = (moment: Moment.Moment): boolean => {
    return this.isHoliday(moment)
      ? false
      : [1, 2, 3, 4, 5].indexOf(moment.day()) >= 0;
  };

  getYearsHolidays(year: number): Moment.Moment[] {
    if (!this.cache || this.cache.year !== year) {
      this.cache = {
        year,
        holidays: map(finishHolidays.year(year, true), holiday =>
          Moment([holiday.year, holiday.month - 1, holiday.day])
        )
      };
    }

    return this.cache.holidays;
  }
}

declare module 'moment' {
  interface Moment {
    isHoliday(): boolean;
    isBusinessDay(): boolean;
    workingDaysDiff(param: Moment.Moment): number;
    getYearsHolidays(year: number): Moment.Moment[];
  }
}

const ext = new MomentExtensions();

Moment.fn.isHoliday = function () {
  return ext.isHoliday(this);
};
Moment.fn.isBusinessDay = function () {
  return ext.isBusinessDay(this);
};
Moment.fn.workingDaysDiff = function (param) {
  return ext.workingDaysDiff(this, param);
};
Moment.fn.getYearsHolidays = function (year) {
  return ext.getYearsHolidays(year);
};

export default Moment;
